import acaf from "../images/badges/acaf.png";
import accs from "../images/badges/accs.png";
import acd from "../images/badges/acd.png";
import acoc from "../images/badges/acoc.png";
import acra from "../images/badges/acra.png";
import ap from "../images/badges/ap.png";
import cp from "../images/badges/cp.png";
import gad from "../images/badges/gad.png";
import gas from "../images/badges/gas.png";
import sa from "../images/badges/sa.png";

export const icxeedDifference = [
  {
    label: "Who we are",
    content: (
      <p>
        Founded in 2022, with over 75 years of founder expertise in delivering
        CX solutions. iCXeed is your digital-first CX delivery partner,
        supporting clients to work smarter across their CX ecosystem and contact
        centre to deliver cognitive customer experiences with analytics, AI, and
        automation that delivers intelligent value for their business and
        embedded innovation change project management.
      </p>
    ),
  },
  {
    label: "What makes us different",
    content: (
      <ul className="list-disc pl-5 space-y-3">
        <li>
          <b>Pure AWS-native expertise:</b> iCXeed deploys, optimises and
          manages CX AI solutions exclusively on AWS.
        </li>
        <li>
          <b>Agile Engagement:</b> Accelerated discovery, pilot/MVP models, and
          early value realisation — no lock-in, no minimum spend, making
          innovation accessible and risk-managed.
        </li>
        <li>
          <b>Scalable, Global Talent Pool:</b> Our growing CX & technology
          practice provides 24/7 support, rapid scaling for enterprise or surge
          demand, and commercial flexibility.
        </li>
        <li>
          <b>Continuous Innovation & Feedback:</b> Embedded operational know-how
          and CX guidance for clients of all sizes. No client is too small.
        </li>
        <li>
          <b>Extensive AWS Funding & Co-Sell Support:</b> Deep experience
          leveraging AWS Migration Acceleration Program (MAP), Customer
          Engagement Incentive (CEI), and other funding channels for client
          pilots and main deployments.
        </li>
        <li>
          <b>Early Adoption:</b> New AWS CX AI products and feature sets - ROI
          positioning, demos and operational configuration, setting up our
          valued client's success.
        </li>
      </ul>
    ),
  },
  {
    label: "Practice Areas",
    content: (
      <ul>
        <li>
          <b>Amazon Connect:</b> Fully managed deployments, covering design,
          seamless migration, integration, and ongoing operational support for
          omnichannel communications including expertise with outbound campaigns
          and social channel integrations.
        </li>
        <li>
          <b>Amazon Bedrock:</b> For complex reasoning required integrated with
          Lex and Q for Connect to offer more intelligent routing, advanced
          customer self service workflows, and automated processing of back
          office workflows related to contact centre experiences.
        </li>
        <li>
          <b>Amazon Quicksight & Sagemaker Unified Studio:</b> For advanced
          analytics solutions, harnessing the Amazon Connect data lake,
          conversational transcripts, auto-QA evaluations, and sentiment
          analysis in a Neptune graph database and conversational user
          interface.
        </li>
        <li>
          <b>Unlimited AI features of Amazon Connect:</b> Provides advisory
          support and operational know-how to maximise the rich feature set of
          Amazon Q in Connect, conversational analytics, automated QA,
          forecasting, capacity planning, and scheduling.
        </li>
        <li>
          <b>Salesforce Contact Centre - Amazon Connect (SCC-AC):</b>
          Experienced partner deploying Amazon Connect integrated within the
          Salesforce workspace for voice and digital channels and implementing
          self-service solutions via Bedrock integrated with Salesforce
          knowledge.
        </li>
        <li>
          <b>Fast-tracked AWS feature adoption:</b> Reusable accelerators,
          enabling rapid rollout of self-service, analytics, and AI-powered
          tools for measurable business value.
        </li>
      </ul>
    ),
  },
  {
    label: "Solution Sweet Spot",
    content: (
      <div>
        <p>iCXeed | Analytics, AI & Automation</p>
        <ul>
          <li>
            <strong>Contact Centre | Amazon Connect Launch</strong>
            <br />
            <a
              href="https://aws.amazon.com/marketplace/pp/prodview-kp45qe3zkckqo?applicationId=AWSMPContessa&ref_=beagle&sr=0-4"
              target="_blank"
              rel="noopener noreferrer"
            >
              Amazon Connect Launch
            </a>{" "}
            | Amazon Connect, Unlimited AI Suite, Migration & Modernisation
          </li>
          <li>
            <strong>Contact Centre | Amazon Connect Managed Service</strong>
            <br />
            <a
              href="https://aws.amazon.com/marketplace/pp/prodview-vqus34fcpmqks?sr=0-1&ref_=beagle&applicationId=AWSMPContessa"
              target="_blank"
              rel="noopener noreferrer"
            >
              Amazon Connect Accelerated
            </a>{" "}
            | Client retention, Amazon Connect optimisation, unlimited AI and
            GenAI roadmap
          </li>
          <li>
            <strong>
              Contact Centre Modernisation | Intelligent IVR Design
            </strong>
            <br />
            <a
              href="https://aws.amazon.com/marketplace/pp/prodview-q3lp7ipqr66pa?sr=0-2&ref_=beagle&applicationId=AWSMPContessa"
              target="_blank"
              rel="noopener noreferrer"
            >
              Intelligent IVR Design
            </a>{" "}
            | Amazon Q, Amazon Lex intelligent conversational design, cognitive
            self-service workflow integration, digital channel promotion
          </li>
          <li>
            <strong>Gen AI Chatbots:</strong>
            <br />
            <a
              href="https://aws.amazon.com/marketplace/pp/prodview-q3lp7ipqr66pa?sr=0-2&ref_=beagle&applicationId=AWSMPContessa"
              target="_blank"
              rel="noopener noreferrer"
            >
              Digital AI Concierge
            </a>{" "}
            | Amazon Lex, Amazon Bedrock, Amazon Connect, real-time analytics,
            and workflow automation
          </li>
          <li>
            <strong>Advanced Contact Centre Reporting & Analytics:</strong>
            <br />
            <a
              href="https://aws.amazon.com/marketplace/pp/prodview-czkuxmj5znzwi?sr=0-6&ref_=beagle&applicationId=AWSMPContessa"
              target="_blank"
              rel="noopener noreferrer"
            >
              CX Perspectives
            </a>{" "}
            | Amazon Bedrock, Amazon Neptune, SageMaker Lakehouse Sagemaker
            Unified Studio, Amazon Quicksight customisable analytics,
            dashboards, and AI models tailored to business needs
          </li>
        </ul>
      </div>
    ),
  },
  {
    label: "Learn. Innovate. Repeat",
    content: (
      <div className="flex flex-col gap-6">
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-y-6 gap-x-4">
          <div className="flex flex-col items-center">
            <img
              src={acaf}
              alt="Amazon Connect AI Fundamentals"
              className="w-[155px] aspect-square"
            />
            <span className="text-[15px] font-semibold text-white leading-5 capitalize">
              78*
            </span>
          </div>
          <div className="flex flex-col items-center">
            <img
              src={acaf}
              alt="Amazon Connect AI Fundamentals"
              className="w-[155px] aspect-square"
            />
            <span className="text-[15px] font-semibold text-white leading-5 capitalize">
              75*
            </span>
          </div>
          <div className="flex flex-col items-center">
            <img
              src={acra}
              alt="Amazon Connect Reporting & Analytics"
              className="w-[155px] aspect-square"
            />
            <span className="text-[15px] font-semibold text-white leading-5 capitalize">
              75*
            </span>
          </div>
          <div className="flex flex-col items-center">
            <img
              src={accs}
              alt="Amazon Connect Communications Specialist"
              className="w-[155px] aspect-square"
            />
            <span className="text-[15px] font-semibold text-white leading-5 capitalize">
              78*
            </span>
          </div>

          <div className="flex flex-col items-center">
            <img
              src={acoc}
              alt="Amazon Connect Outbound Communications"
              className="w-[155px] aspect-square"
            />
            <span className="text-[15px] font-semibold text-white leading-5 capitalize">
              47*
            </span>
          </div>
          <div className="flex flex-col items-center">
            <img
              src={acd}
              alt="Amazon Connect Developer"
              className="w-[155px] aspect-square"
            />
            <span className="text-[15px] font-semibold text-white leading-5 capitalize">
              40*
            </span>
          </div>
          <div className="flex flex-col items-center">
            <img
              src={cp}
              alt="Cloud Practitioner"
              className="w-[155px] aspect-square"
            />
            <span className="text-[15px] font-semibold text-white leading-5 capitalize">
              26*
            </span>
          </div>
          <div className="flex flex-col items-center">
            <img
              src={ap}
              alt="AI Practitioner"
              className="w-[155px] aspect-square"
            />
            <span className="text-[15px] font-semibold text-white leading-5 capitalize">
              05*
            </span>
          </div>

          <div className="flex flex-col items-center">
            <img
              src={gas}
              alt="Generative AI Sales"
              className="w-[155px] aspect-square"
            />
            <span className="text-[15px] font-semibold text-white leading-5 capitalize">
              01*
            </span>
          </div>
          <div className="flex flex-col items-center">
            <img
              src={gad}
              alt="Generative AI Developer"
              className="w-[155px] aspect-square"
            />
            <span className="text-[15px] font-semibold text-white leading-5 capitalize">
              02*
            </span>
          </div>
          <div className="flex flex-col items-center">
            <img
              src={sa}
              alt="Solutions Architect"
              className="w-[155px] aspect-square"
            />
            <span className="text-[15px] font-semibold text-white leading-5 capitalize">
              00*
            </span>
          </div>
        </div>
        <p className="text-[15px] text-white/50 font-semibold text-center leading-5">
          *Quantities of each badge
        </p>
      </div>
    ),
  },
];
